import { Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { Store } from "@ngxs/store";
import { Time, PatientEntity, GetPatientResults, PatientResult } from "huddyapi";
import { HuddyHeatMapComponent } from "../../components/huddy-heat-map/heat-map.component";

@Component({
  selector: 'tracking-analysis',
  templateUrl: 'tracking-analysis.component.html',
  styleUrls: ["./tracking-analysis.component.scss"]
})
export class TrackingAnalysis implements OnInit, OnChanges {


  @Input() patient : PatientEntity;
  @Input() patientResults : PatientResult;
  @ViewChild('graphbox', { static: true }) container: ElementRef;
  @ViewChild('scrollcontainer', { static: true }) scrollcontainer: ElementRef;
  @ViewChild('legendInfo', { static: true }) legendInfo: ElementRef;

  datePickerDate = new Date();
  rangeStartDate : Date;
  rangeEndDate : Date;
  showScrolling : boolean;
  isShowLegend : boolean = false;
  cellHeight : number = 20;

  static VERTICAL_PAD: number = 20;
  static OFFSET_PERCENT : number = .1;
  static MIN_HEATMAP_CELL_SIZE = 40;
  static BAR_GRAPH_HEIGHT = 120;
  static PADDING_MARGIN: number = 60;
  static LABELS_MARGIN: number = 200;


  view: any[] ;
  barView: any[] ;


  // options
  legend: boolean = false;
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  showYAxisLabel: boolean = false;
  showXAxisLabel: boolean = false;
  yAxisLabel: string = 'Symptom';
  xAxisLabel: string = 'Day';
  numSymptoms : number = 3;
  scrollerY : string = '300px';
  scrollerX : number = 0;
  currentRange : string = 'last30';
  barHeight : number = TrackingAnalysis.BAR_GRAPH_HEIGHT;


  colorScheme = {
    domain: 
    ['#e7e7e7', '#aae3f5', '#95bfff',  '#c6c6fd', '#e3b5f5', '#f9aacf', '#d4f6dc']
  };

  barColorScheme = {
    domain: ['#d4f6dc']
  }

  constructor(private store : Store) {

  }


  getHeatMap() : any {
    if (this.patientResults) {
      return this.patientResults.heatmapResults;
    }
    return [];
  }

  getLabels() : string[] {
    let ret : string[] = [];
    if (this.patientResults && this.patientResults.heatmapResults && this.patientResults.heatmapResults.length > 0) {
      for (const k in this.patientResults.heatmapResults[0].series) {
        let cell : any = this.patientResults.heatmapResults[0].series[k];
        ret.push(cell['name']);
      }
      ret = ret.reverse();
    }
    return ret;
  }

  getEvidenceLabels() : string[] {
    let ret : string[] = [];
    if (this.patientResults && this.patientResults.evidence && this.patientResults.evidence.length > 0)  {
      ret = this.patientResults.evidence.map(series => series.name);
    }
    return ret;
  }


  getEvidence() : any {
    if (this.patientResults) {
      return this.patientResults.evidence;
    }
    return [];
  }


  ngOnChanges(changes: SimpleChanges): void {
    this.setGraphSizes();
  }
  ngOnInit(): void {
    
  }

  setGraphSizes() {
      let clientWidth : number = this.container.nativeElement.clientWidth - TrackingAnalysis.PADDING_MARGIN - TrackingAnalysis.LABELS_MARGIN;
      
      let offset : number = TrackingAnalysis.LABELS_MARGIN + (TrackingAnalysis.OFFSET_PERCENT * clientWidth);
      let height : number = (this.patientResults) ? this.patientResults.heatmapResults[0].series.length * TrackingAnalysis.MIN_HEATMAP_CELL_SIZE : 300;
      this.barHeight  = TrackingAnalysis.BAR_GRAPH_HEIGHT ;
     // console.log('setGraphSizes', height, this.patientResults.heatmapResults[0].series.length)
      let width = (this.patientResults) ? 
        Math.max(1,  (this.patientResults.heatmapResults.length /45)) * clientWidth :   clientWidth;

      //this.container.nativeElement.style.height = (height + TrackingAnalysis.VERTICAL_PAD + 40) + 'pt';
      this.showScrolling = width > clientWidth;  
      if (this.showScrolling) {
        this.scrollerY = 'calc(-20pt + ' + (this.container.nativeElement.offsetTop + (.5 * this.container.nativeElement.clientHeight)) + 'px)';
      }
      this.scrollcontainer.nativeElement.style.width = width + 'px';
      if (this.patientResults)
        this.cellHeight = Math.round(((height - 48) / this.patientResults.heatmapResults[0].series.length));
      console.log('Cell height', height, this.cellHeight);
      this.view = [width, height];
      this.barView = [width, this.barHeight];
    
  }

  scroll(amount : number) {
  
    this.scrollerX += amount ;
    this.scrollcontainer.nativeElement.style.left  = this.scrollerX + 'px';
    console.log(amount, this.scrollcontainer.nativeElement.offsetLeft, this.scrollerX);
  }

  @HostListener('window:resize', ['$event'])
onResize(event) {
  this.setGraphSizes();
}

 
  onRangeSelected() {
    console.log( this.currentRange);
    let today : number = new Time().getEpochDay();
    let start : number = today - 29;
    let end : number = today;

    if (this.currentRange === 'last90') {
      start = today - 89;
    } else if (this.currentRange === 'lastYear') {
      start = today - 364;
    } else if (this.currentRange === 'earliest') {
      start = -1;
    } else if (this.currentRange === 'custom') {
      start = (this.rangeStartDate) ? new Time(this.rangeStartDate.toISOString()).getEpochDay() : 0;
      end =  (this.rangeEndDate) ? new Time(this.rangeEndDate.toISOString()).getEpochDay() : 0;
    }

    if (end - start > 7) {
      this.store.dispatch( new GetPatientResults(this.patient.id, start, end ));
      this.scrollerX = 0 ;
      this.scrollcontainer.nativeElement.style.left  = this.scrollerX + 'px';
    }
  }

  onCustomRangeDateChange() {
    console.log( this.currentRange, this.rangeStartDate, this.rangeEndDate);
    if (this.currentRange === 'custom' && this.rangeStartDate && this.rangeEndDate) {
      let start = new Time(this.rangeStartDate.toISOString()).getEpochDay();
      let end =  new Time(this.rangeEndDate.toISOString()).getEpochDay();
      if (end - start > 7)
        this.store.dispatch( new GetPatientResults(this.patient.id, start, end ));
    }
  }


  toggleLegend() {   
    this.isShowLegend = !this.isShowLegend;
  }

  getLegendItems() : string[] {
    return HuddyHeatMapComponent.trainingValueDomain;
  }

  getSchemaColor(index : number) : string {
    return index < this.colorScheme.domain.length ? this.colorScheme.domain[index] : '';
  }


  rangeOptions : any[] =  [
    {
      displayName: "Last 30 days",
      value: "last30"
    },
    {
      displayName: "Last 90 days",
      value: "last90"
    },
    {
      displayName: "Last year",
      value: "lastYear"
    },
    {
      displayName: "Since earliest",
      value: "earliest"
    },
    {
      displayName: "Custom",
      value: "custom"
    }
  ];

}